import assignToThis from '../../helper/assignToThis';
import { ObjectOnly } from '@/classes/ObjectOnly';

export class EcoOM {
  public pvCost: number | null = null;
  public pvFixedCost: number | null = null;
  public generatorFixedCost: number | null = null;
  public generatorVariableCost: number | null = null;
  public batteryCost: number | null = null;

  public constructor(obj: ObjectOnly = {}) {
    assignToThis(this, obj);
  }
}
